




































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import ChangeRadio from '@/components/changeRadio/changeRadio.vue';
import { institutionServer, userServe } from '@/api/installServer';
import { deepClone } from '@/util/deepClone';

@Component({
  components: { ChangeRadio },
})
export default class EditBranch extends Vue {
  private showUnit = true; // 单位
  private showDept = false; // 部门
  private showStaff = false; // 人员
  private unitId = '';
  private departmentId = '';
  private visible = false;
  private input: any = '';
  private showList: any = true;
  private checkedText: any = [];
  private unitsCheckd: any = [];
  private checkedInnerText: any = [];
  private checkedRoleText: any = [];
  private dataList: any = []; // 暂时代替传入的数据
  private isCheckedId: any = '';

  private units: any = []; // 单位 table
  private departments: any = []; // 部门 table
  private staffs: any = []; // 人员 table

  private receiveData = [];
  private checkData: any = [];

  private arr: any = [];

  private created() {}

  private mounted() {}

  // 单位
  private getUnit() {
    institutionServer
      .getCompanyList({})
      .then((res: any) => {
        this.units = res.data;
        this.$nextTick(() => {
          this.units.forEach((langGe: any) => {
            langGe.objType = 'space';
            this.checkData.map((re: any) => {
              if (re.objId === langGe.id) {
                (this.$refs.unitsTable as any).toggleRowSelection(langGe, true);
              }
            });
          });
        });
      })
      .catch((error: any) => {
        this.$message.error('获取单位数据失败');
      });
  }

  // 部门
  private getDepartment() {
    institutionServer
      .getAllData({
        spaceId: this.unitId,
      })
      .then((res: any) => {
        this.departments = res.data;
        this.$nextTick(() => {
          this.departments.forEach((laZe: any) => {
            laZe.objType = 'department';
            laZe.objId = laZe.id;
            this.checkData.map((re: any) => {
              if (re.objId === laZe.id) {
                (this.$refs.multipleTable as any).toggleRowSelection(laZe, true);
              }
            });
          });
        });
      })
      .catch((error: any) => {
        this.$message.error('获取部门数据失败');
      });
  }

  // 人员
  private getStaff() {
    userServe
      .getPageDataAll({
        deptId: this.departmentId,
      })
      .then((res: any) => {
        this.staffs = res.data;
        this.$nextTick(() => {
          this.staffs.forEach((laZe: any) => {
            laZe.objType = 'staff';
            laZe.objId = laZe.id;
            this.checkData.map((re: any) => {
              if (re.objId === laZe.id) {
                (this.$refs.multipleInnerTable as any).toggleRowSelection(laZe, true);
              }
            });
          });
        });
      })
      .catch((error: any) => {
        this.$message.error('获取部门数据失败');
      });
  }

  private async showDialog(data: any) {
    this.receiveData = data;
    this.dataList = data;
    this.checkData = deepClone(data);
    this.getUnit();
    const a: any = [];

    data.forEach((item: any) => {
      switch (item.objType) {
        case 'space':
          item.objId && this.unitsCheckd.push(item);
          break;
        case 'department':
          item.objId && this.checkedText.push(item);
          break;
        case 'staff':
          item.objId && this.checkedInnerText.push(item);
          break;
      }
    });

    this.visible = true;
  }

  selectionRow(selection: any, row?: any) {
    const selected = selection.length && selection.indexOf(row) !== -1; //为true时选中，为 0 时（false）未选中
    if (selected) {
      if (this.staffs) {
        selection.map((re: any) => {
          this.arr.push(re);
        });
      }
      this.checkedInnerText = this.unique(this.arr); // 对存储的数组去重后赋值给列表
    } else {
      this.checkedInnerText.forEach((reData: any, index: any) => {
        if (row.id === reData.id) {
          this.checkedInnerText.splice(index, 1);
        }
      });
    }
  }

  //表格全选事件
  selectionRowAll(selection: any, row: any) {
    const selected: any = selection.length && selection.indexOf(row) !== -1; //为true时选中，为 0 时（false）未选中
    const newArr: any = [];
    if (!selected) {
      if (this.staffs) {
        selection.map((res: any, index: any) => {
          this.$set(newArr, index, res);
        });
        this.arr = this.arr.concat(newArr);
      }
      this.checkedInnerText = this.unique(this.arr); // 对存储的数组去重后赋值给列表
    }
    if (selected === 0) {
      this.checkedInnerText.forEach((re: any, index: any) => {
        this.staffs.forEach((res: any, innerIndex: any) => {
          if (re.id === res.id) {
            for (let i = 0; i < this.staffs.length; i++) {
              this.checkedInnerText.splice(index, 1);
            }
          }
        });
      });
    }
  }

  /**
     @description: 判断是否可以点击下级
     @author: cxf
     @update: cxf 2021/7/15 9:35
     **/
  private isClick(id: any) {
    const num: any = this.checkedText.findIndex((item: any) => {
      return item.id === id;
    });

    return num !== -1;
  }

  private isClick1(id: any) {
    const num: any = this.unitsCheckd.findIndex((item: any) => {
      return item.id === id;
    });

    return num !== -1;
  }

  /**
   * 关闭窗口
   */
  private hideDialog() {
    this.close();
  }

  /**
   * 【表单】弹窗关闭
   */
  private close() {
    this.visible = false;
    this.showUnit = true;
    this.showStaff = false;
    this.showDept = false;
    this.checkedText = [];
    this.unitsCheckd = [];
    this.checkedInnerText = [];
    this.checkedRoleText = [];
    this.showList = true;
    this.arr = [];
    this.isCheckedId = '';
    (this.$refs.unitsTable as any).clearSelection();
    (this.$refs.multipleTable as any).clearSelection();
    (this.$refs.multipleInnerTable as any).clearSelection();
  }

  private save() {
    const ListOne: any = []; // 存储id
    const ListTwo: any = []; // 去重之后的数组
    this.unitsCheckd.map((res: any) => {
      ListOne.push({
        objId: res.id || res.objId,
        objName: res.name || res.objName,
        objType: 'space',
      });
    });

    this.checkedText.map((res: any) => {
      ListOne.push({
        objId: res.id || res.objId,
        objName: res.name || res.objName,
        objType: 'department',
      });
    });

    this.checkedInnerText.map((re: any) => {
      ListOne.push({
        objId: re.id || re.objId,
        objName: re.name || re.objName,
        objType: 'staff',
      });
    });

    this.dataList = ListTwo;
    this.$emit('backData', ListOne);
    this.hideDialog();
  }

  /**
     @description: 选中的值
     @author: cxf
     @update: cxf 2021/7/12 14:04
     **/
  private handleSelectionChange(val: any, row: any) {
    const index = this.checkedText.findIndex((item: any) => {
      return item.objId === row.id;
    });
    console.log(index);

    if (index > -1) {
      this.checkedText.splice(index, 1);
    } else {
      this.checkedText.push(row);
    }
  }

  private handleSelectionChangeStaff(val: any, row: any) {
    const index = this.checkedInnerText.findIndex((item: any) => {
      return item.objId === row.id;
    });

    if (index > -1) {
      this.checkedInnerText.splice(index, 1);
    } else {
      this.checkedInnerText.push(row);
    }
  }

  /**
     @description: 选中的值
     @author: cxf
     @update: cxf 2021/7/12 14:04
     **/
  private handleSelectionChange1(val: any, row: any) {
    const index = this.unitsCheckd.findIndex((item: any) => {
      return item.objId === row.id;
    });
    console.log(index);

    if (index > -1) {
      this.unitsCheckd.splice(index, 1);
    } else {
      this.unitsCheckd.push(row);
    }
  }

  /**
     @description: 数组去重
     @author: cxf
     @update: cxf 2021/7/26 16:20
     **/
  public unique(arr: any) {
    for (let i = 0; i < arr.length; i++) {
      for (let j = i + 1; j < arr.length; j++) {
        if (arr[i].id === arr[j].id || arr[i].id === undefined || arr[j].id === undefined) {
          // 第一个等同于第二个，splice方法删除第二个
          arr.splice(j, 1);
          j--;
        }
      }
    }
    return arr;
  }

  /**
     @description: 数组去重
     @author: cxf
     @update: cxf 2021/7/26 16:20
     **/
  public uniqueOne(arr: any) {
    for (let i = 0; i < arr.length; i++) {
      for (let j = i + 1; j < arr.length; j++) {
        if (arr[i].objId === arr[j].objId || arr[i] === undefined || arr[j] === undefined) {
          arr.splice(j, 1);
          j--;
        }
      }
    }
    return arr;
  }

  unitsDelete(arr: any, index: any) {
    (this.$refs.unitsTable as any).clearSelection();

    const indexS = this.checkData.findIndex((item: any) => {
      return item.objId === arr[index].objId;
    });

    this.checkData.splice(indexS, 1);

    const indexI = this.unitsCheckd.findIndex((item: any) => {
      return item.objId === arr[index].objId;
    });

    this.unitsCheckd.splice(indexI, 1);

    this.units.forEach((laZe: any) => {
      this.checkData.map((re: any) => {
        if (re.objId === laZe.id) {
          (this.$refs.unitsTable as any).toggleRowSelection(laZe, true);
        }
      });
    });
  }

  /**
     @description: 对已选的数据进行删除
     @author: cxf
     @update: cxf 2021/7/12 15:15
     **/
  private indexDelete(arr: any, index: any) {
    (this.$refs.multipleTable as any).clearSelection();

    const indexS = this.checkData.findIndex((item: any) => {
      return item.objId === arr[index].objId;
    });

    this.checkData.splice(indexS, 1);

    const indexI = this.checkedText.findIndex((item: any) => {
      return item.objId === arr[index].objId;
    });

    this.checkedText.splice(indexI, 1);

    this.departments.forEach((laZe: any) => {
      this.checkedText.map((re: any) => {
        if (re.objId === laZe.id) {
          (this.$refs.multipleTable as any).toggleRowSelection(laZe, true);
        }
      });
    });
  }

  /**
     @description: 对下级已选的数据进行删除
     @author: cxf
     @update: cxf 2021/7/12 15:15
     **/
  private indexInnerDelete(arr: any, index: any) {
    (this.$refs.multipleInnerTable as any).clearSelection();

    const indexS = this.checkData.findIndex((item: any) => {
      return item.objId === arr[index].objId;
    });

    this.checkData.splice(indexS, 1);

    const indexI = this.checkedInnerText.findIndex((item: any) => {
      return item.objId === arr[index].objId;
    });

    this.checkedInnerText.splice(indexI, 1);

    this.staffs.forEach((laZe: any) => {
      this.checkData.map((re: any) => {
        if (re.objId === laZe.id) {
          (this.$refs.multipleInnerTable as any).toggleRowSelection(laZe, true);
        }
      });
    });
  }

  private isShowNextList(data: any) {
    this.unitId = data.id;
    this.getDepartment();
    this.showUnit = false;
    this.showDept = true;
  }

  /**
   * */
  private nextList(data: any) {
    this.isCheckedId = data.id;
    this.showStaff = true;
    this.staffs = data.staffList;
    this.showDept = false;
    this.departmentId = data.id;
    this.getStaff();
  }
}
